import React from 'react';
import { useLocation, matchPath } from 'react-router';
import { Link } from 'react-router-dom';

// Types
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';

// Components
import { WpModal } from 'Wpds/components/modal';
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { WpButton } from 'Wpds/components/button';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

// Styles
import './TransferToPIBillingModal.scss';
import { useOrganization } from 'Shared/utils/hooks/use-organization';
import { useFlags } from 'launchdarkly-react-client-sdk';

const TransferToPIBillingModal = () => {
  const { pathname } = useLocation();
  const { isPiOrganization } = useOrganization();
  const { featureFlagEnableTransferToPiBillingModal } = useFlags();

  const { intercomContactSalesEventName } = useApp();
  const { isOrgAdmin } = useCurrentUser();
  const isSettingsPage = matchPath(pathname, { path: [PageUrls.SETTINGS_PAGE] });
  const isAdminPage = matchPath(pathname, { path: [PageUrls.ADMIN] });
  const isOnboardingRoute = matchPath(pathname, { path: [PageUrls.ONBOARDING_WIZARD] });

  if (isSettingsPage || isAdminPage || isOnboardingRoute) return null;
  if (isPiOrganization) return null;
  if (!featureFlagEnableTransferToPiBillingModal) return null;
  const baseClassName = 'TransferToPIBillingModal';

  return (
    <WpModal size="full" isOpen>
      <WpPageLayout>
        <WpPageBody>
          <div className={`${baseClassName}__util-nav`}>
            <Link to={PageUrls.SETTINGS_PROFILE_PAGE} className={`${baseClassName}__util-nav__link`}>
              Account Settings
            </Link>
            {isOrgAdmin && (
              <Link to={PageUrls.ADMIN_MEMBERS} className={`${baseClassName}__util-nav__link`}>
                Admin Console
              </Link>
            )}
          </div>
          <div className={`${baseClassName}__empty`}>
            <EmptyStateContainer
              title="Your account has been deactivated."
              subTitle="To continue using PI Perform, please reach out to sales to renew your subscription."
              button={
                <WpButton size="lg" dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>
                  Contact Sales
                </WpButton>
              }
              image={Illustrations.stopwatch}
            />
          </div>
        </WpPageBody>
      </WpPageLayout>
    </WpModal>
  );
};

export default TransferToPIBillingModal;
